import * as WidgetApi from '@wix/ambassador-innovation-widget-v1-message/types';

import { DuplexerConnection, DuplexerChannel } from '@/services/duplexer';

export const enum DuplexerMessageType {
  NewMessageEvent = 'new-message-event',
  NewConversationEvent = 'new-conversation-event',
}

export type NewMessageEvent = WidgetApi.Message;
export type MessageTypingEvent = {
  expiryMs: number;
  answerTo: string;
  conversationId: string;
};
export type DuplexerMessage = NewMessageEvent | MessageTypingEvent;
export type DuplexerMergeConversationsMessage = {
  oldConversationIds: string[];
  targetConversationId: string;
};

export const isNewMessageEvent = (
  message: DuplexerMessage,
): message is NewMessageEvent => {
  return 'id' in message && message.id !== undefined && message.id !== null;
};

export const isMessageTypingEvent = (
  message: DuplexerMessage,
): message is MessageTypingEvent => {
  return (
    'expiryMs' in message &&
    message.expiryMs !== undefined &&
    message.expiryMs !== null
  );
};

export class ConversationChannel {
  private readonly channel: DuplexerChannel;

  constructor(public readonly id: string, connection: DuplexerConnection) {
    this.channel = connection.subscribe(id);
  }

  onNewMessageEvent(handler: (message: DuplexerMessage) => void) {
    this.channel.on(DuplexerMessageType.NewMessageEvent, handler);
  }

  onNewConversationEvent(
    handler: (conversation: DuplexerMergeConversationsMessage) => void,
  ) {
    this.channel.on(DuplexerMessageType.NewConversationEvent, handler);
  }

  close() {
    this.removeAllListeners();
    this.unsubscribe();
  }

  unsubscribe() {
    this.channel.unsubscribe();
  }

  removeAllListeners() {
    this.channel.removeAllListeners();
  }
}

export const createConversationChannel = (
  conversationId: string,
  connection: DuplexerConnection,
): ConversationChannel => {
  return new ConversationChannel(conversationId, connection);
};
